import { Stack, MenuItem, Typography } from "@mui/material";
import { MainInput } from "../../app/components/Styles";

export const WA_TEMPLATE_CUSTOM = "__custom__";

/** Resolve picker state to API value: null = default, else template name string */
export function resolveWhatsappTemplateField(sel, custom) {
  if (!sel) return null;
  if (sel === WA_TEMPLATE_CUSTOM) {
    const t = (custom || "").trim();
    return t === "" ? null : t;
  }
  return sel;
}

export function deriveInitialWhatsappField(saved, templateDocs) {
  if (!saved) return { sel: "", custom: "" };
  const names = (templateDocs || []).map((d) => d.name);
  if (names.includes(saved)) return { sel: saved, custom: "" };
  return { sel: WA_TEMPLATE_CUSTOM, custom: saved };
}

/**
 * @param {object} props
 * @param {string} props.label
 * @param {{ sel: string, custom: string }} props.value
 * @param {function} props.onChange
 * @param {import("react").CSSProperties} [props.sx]
 * @param {object} [props.templates] paginate result with docs
 */
export function WhatsappEventTemplatePicker({ label, value, onChange, templates }) {
  const docs = templates?.docs || [];
  return (
    <Stack spacing={0.5}>
      <MainInput
        select
        fullWidth
        label={label}
        value={value.sel}
        onChange={(e) => onChange({ ...value, sel: e.target.value })}
        SelectProps={{
          MenuProps: {
            PaperProps: { sx: { bgcolor: "var(--platform-surface)", color: "var(--primaryPurple)" } },
          },
        }}
      >
        <MenuItem value="" sx={{ color: "var(--primaryPurple)" }}>
          Default (none)
        </MenuItem>
        {docs.map((tpl) => (
          <MenuItem key={tpl._id} value={tpl.name} sx={{ color: "var(--primaryPurple)" }}>
            {tpl.name} — {tpl.language} — {tpl.status}
          </MenuItem>
        ))}
        <MenuItem value={WA_TEMPLATE_CUSTOM} sx={{ color: "var(--primaryPurple)" }}>
          Custom template name…
        </MenuItem>
      </MainInput>
      {value.sel === WA_TEMPLATE_CUSTOM && (
        <MainInput
          fullWidth
          label="Custom template name"
          placeholder="my-template-name"
          value={value.custom}
          onChange={(e) => onChange({ ...value, custom: e.target.value })}
        />
      )}
      {value.sel === WA_TEMPLATE_CUSTOM && (
        <Typography variant="caption" sx={{ color: "text.secondary", pl: 0.5 }}>
          No spaces, hyphen separated (Meta template name as registered)
        </Typography>
      )}
    </Stack>
  );
}
